import React, { useState } from "react";

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  expandIcon: {
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
  xmlContainer: {
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    overflowX: 'auto',
    maxHeight: '400px',
  },
  xmlContent: {
    fontFamily: 'Monaco, Menlo, "Ubuntu Mono", Consolas, monospace',
    fontSize: '12px',
    lineHeight: '1.5',
    whiteSpace: 'pre',
    margin: 0,
    '& .xml-tag': {
      color: '#0066cc',
    },
    '& .xml-attr-name': {
      color: '#aa0d91',
    },
    '& .xml-attr-value': {
      color: '#c41a16',
    },
    '& .xml-comment': {
      color: '#5d6c79',
      fontStyle: 'italic',
    },
  },
}));

export default function SvarXml(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  if (!props || 
     !props.Anmodning ||
     !props.Anmodning.svar_xml ) {
    return (<div></div>);
  }
    
  function formatXml(xml) {
    if (!xml) return '';
    
    // Remove extra whitespace and newlines
    let formatted = xml.replace(/>\s*</g, '><');
    
    // Add indentation
    let indent = 0;
    const tab = '  ';
    formatted = formatted.replace(/(<[^>]+>)/g, (match) => {
      let result = '';
      
      // Self-closing or closing tag
      if (match.startsWith('</') || match.endsWith('/>')) {
        if (match.startsWith('</')) {
          indent--;
        }
        result = '\n' + tab.repeat(indent) + match;
        if (match.endsWith('/>')) {
          // No change in indent for self-closing
        }
      } else {
        // Opening tag
        result = '\n' + tab.repeat(indent) + match;
        indent++;
      }
      
      return result;
    });
    
    return formatted.trim();
  }

  function highlightXml(xml) {
    if (!xml) return '';
    
    const formatted = formatXml(xml);
    
    // Simple syntax highlighting using regex
    return formatted
      // Comments
      .replace(/(&lt;!--.*?--&gt;|<!--.*?-->)/g, '<span class="xml-comment">$1</span>')
      // Tags with attributes
      .replace(/(&lt;\/?)([a-zA-Z0-9:_-]+)((?:\s+[a-zA-Z0-9:_-]+(?:=&quot;[^&quot;]*&quot;|="[^"]*")?)*)(\s*\/?&gt;|>)/g, 
        (match, openBracket, tagName, attrs, closeBracket) => {
          let result = '<span class="xml-tag">' + openBracket + tagName;
          
          if (attrs) {
            // Highlight attributes
            attrs = attrs.replace(/([a-zA-Z0-9:_-]+)(=)(&quot;[^&quot;]*&quot;|"[^"]*")/g, 
              '<span class="xml-attr-name">$1</span>$2<span class="xml-attr-value">$3</span>');
            result += attrs;
          }
          
          result += closeBracket + '</span>';
          return result;
        });
  }

  const handleToggle = () => {
    setOpen(!open);
  };

  const xmlContent = props.Anmodning.svar_xml;

  return (
    <div>
      <div className={classes.header} onClick={handleToggle}>
        <span>Svar XML</span>
        <IconButton
          className={`${classes.expandIcon} ${open ? classes.expandIconOpen : ''}`}
          size="small"
        >
          <ExpandMoreIcon />
        </IconButton>
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <div className={classes.xmlContainer}>
          <pre className={classes.xmlContent}>
            {formatXml(xmlContent)}
          </pre>
        </div>
      </Collapse>
    </div>
  );
}